import React from 'react'
import DynamicMaster from '../../Components/DynamicMaster/DynamicMaster'

const AllowanceMaster = () => {
  return (
    <>
        <DynamicMaster id={8} dashboardId={9} />
    </>
  )
}

export default AllowanceMaster
